import React from 'react'
import { graphql, StaticQuery } from 'gatsby'
import { GatsbyImage } from "gatsby-plugin-image"

const Image = (props) => (

    <StaticQuery
        query={graphql`
     query {
                desktopImage: allFile(filter:{extension:{regex:"/(jpeg|jpg|gif|png)/"}}) {
                    edges {
                        node {
                            relativePath
                            name
                            childImageSharp {
                                gatsbyImageData(
                                  layout: CONSTRAINED
                                  width: 800
                                  placeholder: NONE
                                  outputPixelDensities: [0.25, 0.5, 1, 2, 3]
                                  formats: [AUTO, WEBP, AVIF]
                                )
                            }
                        }
                    }
                }
            }
  `}

        render={(data) => {

            const imagesD = data.desktopImage.edges.find(n => {
                return n.node.relativePath.includes("/" + props.filename + ".jpg");
            });

            const imageDesktop = imagesD.node.childImageSharp.gatsbyImageData;

            const imageAlt = props.alt ? props.alt : imagesD.node.name;
            
            return (
                <GatsbyImage className={props.className}
                    alt={imageAlt}
                    image={imageDesktop}
                />
            );
        }}
    />
);

export default Image;